/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable no-tabs */
import React, { Suspense, useEffect } from 'react';
import Amplify from 'aws-amplify';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import Admin from './Admin';
import Loader from './AppLoader';
import Logout from './Component/Auth/Logout';
import Home from './Component/Home';

import Session from './Service/Session';
import LoanCalculator from './LoanCalculator';
import EmbedCalculator from './LoanCalculator/embed';

Session.trackVisitReferral();

const AppConfig = window.AppConfig;
const USER_TYPE = window.AppConfig.USER_TYPES;
Amplify.configure({ Auth: AppConfig.COGNITO });

export default function App({ history }) {
	const currentUser = Session.get('CURRENT_USER_INFO');

	const userType = currentUser !== null ? currentUser.attributes['custom:user_type'] : null;

	return (
		<Suspense fallback={<Loader />}>
			<Router history={history}>
				<Switch>
					<Route component={Home} exact path="/" />
					<Route component={Home} path="/loan/:id" />
					<Route component={Home} path="/admin/loans/:id" />
					<Route component={Home} path="/amortization-table/:id" />
					<Route component={LoanCalculator} path="/loan-calculator" />
					<Route component={EmbedCalculator} path="/loan-calculator-embed" />
					<Route component={Home} path="/modify-loan/:id" />
					<Route component={Home} path="/signup" />
					<Route component={Home} path="/signin" />
					<Route component={Home} path="/profile" />
					<Route component={Logout} path="/logout" strict />
					{!currentUser ? (
						<Redirect to="/" />
					) : (
						<Route component={userType !== USER_TYPE.NORMAL_USER ? Admin : Home} path="/admin" />
					)}
					<Route component={Home} path="*" />
				</Switch>
			</Router>
		</Suspense>
	);
}
